import React, { useState } from "react";
import { getSectorByName, updateSector } from "../../../ruleService";
import { showDangerToast, showSuccessToast } from "../../../../validation/ToastContainer";
import * as ruleService from "../../../ruleService";
import SectorNameField from "./SectorNameField";
import { hasErrors } from "../../../../utils";
import { connect } from "react-redux";
import TargetTypeWizardModal from "../TargetTypeWizardModal";

function EditSectorModal({ setShowModal, validationErrors, selectedSector }) {

    const [sector, setSector] = useState(selectedSector);

    const onSaveClick = async () => {

        const serverSector = await getSectorByName(sector.name);
        let savedSector;

        if ((serverSector.error && serverSector.statusCode === 404) || serverSector.id === sector.id) {
            savedSector = await updateSector(sector);
        } else {
            showDangerToast(`Sector with name '${sector.name}' already exist`, "Save Sector")
        }

        if (savedSector) {
            showSuccessToast("Sector updated", "Save Sector");
            ruleService.loadRuleTargetTypes({ includeAllMsbs: true }).then(() => setShowModal(false));
        }

    }

    return (
        <TargetTypeWizardModal
            title="Edit Sector Wizard"
            subtitle="Update the selected sector target type."
            onClose={() => setShowModal(false)}
            onSubmit={onSaveClick}
            submitLabel="Update"
            submitDisabled={hasErrors(validationErrors)}
            contentClassName="target-type-wizard-form__content--compact"
        >
            <SectorNameField sector={sector} setSector={setSector} />
        </TargetTypeWizardModal>
    );

}

function mapStateToProps(state) {
    return {
        validationErrors: state.validation
    }
}

export default connect(mapStateToProps)(EditSectorModal);
